import { Box } from '@material-ui/core';
import React from 'react';

export const Tag = ({
  children,
  style,
}: {
  children: React.ReactNode;
  style?: React.CSSProperties;
}) => {
  return (
    <Box
      display="inline-block"
      style={{
        borderRadius: 8,
        padding: '2px 9px',
        ...style,
      }}
    >
      {children}
    </Box>
  );
};
